<template>
  <component :is="layout">
    <router-view />
  </component>
  <ContactModal 
      :visible="showContactModal"
      @close="closeContactModal"
    />
</template>

<script setup>
import { computed, ref, provide } from 'vue'
import { useRoute } from 'vue-router'
import BlankLayout from '@/layouts/BlankLayout.vue'
import HomeLayout from '@/layouts/HomeLayout.vue'
import ContactModal from '@/components/ContactModal.vue'

const route = useRoute()
const layout = computed(() => {
  const layoutType = route.meta?.layout
  if (layoutType === 'home') return HomeLayout
  return BlankLayout
})
const showContactModal = ref(false)
provide('showContactModal', showContactModal)

const closeContactModal = () => {
  showContactModal.value = false
}

</script>

<style lang="scss">
@use '@/assets/styles/global.scss' as *;

#app {
  background-color: #f5f5f5;
}
</style>
